<template>
  <div class="product-details">
    <div class="title">
      {{ title }}产品明细
    </div>
    <div class="row">
      <div class="address-content">
        <span>配送至：</span>
        <div class="adressBox">
          <div v-if="address.isDefault" class="defTab">
            默认
          </div>
          <div class="item">
            {{ address.province }}
          </div>
          <div class="item">
            {{ address.city }}
          </div>
          <div class="item">
            {{ address.county }}
          </div>
          <div class="item">
            {{ address.receiptAddress }}
          </div>
          <div class="item">
            {{ address.receiverName }}
          </div>
          <div class="item">
            {{ address.receiverPhone }}
          </div>
        </div>
        <el-button
          v-if="address.receiverName"
          type="text"
          style="padding: 0; margin-left: 15px"
          disabled
        >
          更改地址
        </el-button>
      </div>
      <div class="select-box">
        <el-date-picker
          v-model="deliverTimeValue"
          type="date"
          placeholder="批量修改变更客期"
          disabled
        />
        <el-select
          v-model="freightPropertiesValue"
          placeholder="请选择货运属性"
          disabled
          style="marginLeft: 18px"
        >
          <el-option
            v-for="item in freightPropertiesList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          size="mini"
          class="ml-18 btn-setting"
          disabled
          @click="setDeliverTime"
        >
          批量设置
        </el-button>
        <el-button
          type="default"
          size="mini"
          class="ml-18 btn-setting"
          :class="{ 'btn-disabled': isDisabled }"
          disabled
          @click="setSingleMaterialNum()"
        >
          设置料号
        </el-button>
      </div>
    </div>
    <!-- table row -->
    <div class="table-box">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="left" width="55" fixed="left" />
        <el-table-column
          prop="productCode"
          label="销售产品代码"
          align="left"
        />
        <el-table-column prop="productName" label="产品型号" align="left" />
        <el-table-column
          prop="materialNum"
          label="料号"
          align="left"
          width="160px"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.materialNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productNum" label="数量" align="left">
          <template slot-scope="scope">
            <span>{{ scope.row.productNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialUnit" label="单位" align="left" />
        <el-table-column
          prop="beforeSplitPrice"
          label="拆分前单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productPriceAdd"
          label="拆分前总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPrice"
          label="实际结算单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPriceAdd"
          label="实际结算总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          v-if="title !== '价外费用合同'"
          prop="borrowToSaleFlg"
          label="测试借条转订单"
          align="left"
        >
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.borrowToSaleFlg" disabled />
          </template>
        </el-table-column>
        <el-table-column
          prop="freightProperties"
          label="货运属性"
          align="left"
          width="160px"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.freightProperties"
              disabled
              placeholder="请选择货运属性"
            >
              <el-option
                v-for="item in freightPropertiesList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="title !== '价外费用合同'"
          prop="freightProperties"
          label="电源线规格"
          align="left"
          width="160px"
        >
          <template v-slot="{row}">
            <el-input
              v-model="row.powerCord"
              disabled
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="expectedDeliveryDate"
          label="期望发货日期"
          align="left"
          width="160px"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.expectedDeliveryDate.substring(0, 10) || "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="taxRate"
          label="税率"
          align="right"
          header-align="left"
          width="160px"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.taxRate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="serviceDesc" label="服务备注" align="left">
          <template slot-scope="scope">
            {{ scope.row.serviceDesc || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" align="left">
          <template slot-scope="scope">
            {{ scope.row.remarks || "-" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    },
    address: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      partNofreightPropertiesList: [],
      multipleSelection: [],
      deliverTimeValue: '',
      freightPropertiesValue: '',
      freightPropertiesList: [{
        value: '直发',
        label: '直发'
      }, {
        value: '不发货有回执',
        label: '不发货有回执'
      }, {
        value: '不发货无回执',
        label: '不发货无回执'
      }, {
        value: '供应商直发',
        label: '供应商直发'
      }, {
        value: '软件订单',
        label: '软件订单'
      }]
    };
  },
  components: {},
  computed: {
    // 判断设置按钮和下拉框是否可操作
    isDisabled () {
      if (this.multipleSelection.length < 2) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 合计函数
    getSummaries (params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const noSumList = [1, 2, 3, 5, 6, 8, 10, 11, 12, 13, 14, 15];
        if (noSumList.includes(index)) {
          sums[index] = '';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          });
          sums[index] += '';
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 批量设置发货日期
    setDeliverTime () {
      if (!this.deliverTimeValue) {
        return Message.info('请先选择期望发货时间');
      }
      this.multipleSelection.forEach(item => {
        item.expectedDeliveryDate = this.deliverTimeValue;
      });
      this.deliverTimeValue = '';
      this.$refs.multipleTable.clearSelection();
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details {
  margin-top: 12px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  .title {
    color: #383838;
    font-size: 14px;
    font-weight: bold;
  }
  .row {
    margin-top: 12px;
    margin-bottom: 12px;
    font-size: 14px;
    .btn-setting {
      width: 90px;
      height: 30px;
      font-size: 14px;
    }
  }
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ml-18 {
  margin-left: 18px;
}
.btn-disabled {
  color: #b8b8b8;
  font-size: 14px;
  border-radius: 4px;
  background-color: rgba(245, 245, 245, 1);
  border: 1px solid #d9d9d9;
}
.table-box {
  ::v-deep .el-table__footer-wrapper {
    tbody {
      td.el-table__cell {
        background-color: transparent;
        font-weight: bold;
      }
    }
  }
  ::v-deep .el-table__row {
    .el-table__cell {
      .el-select,
      .el-date-editor {
        width: 130px;
      }
      .el-date-editor {
        .el-input__prefix {
          .el-icon-date {
            position: absolute;
            right: -122px;
          }
        }
      }
    }
  }
}
.row {
  .select-box {
    ::v-deep .el-date-editor {
      width: 270px;
      .el-icon-date {
        position: absolute;
        right: -262px;
      }
    }
  }
}

.product-details {
  ::v-deep .el-date-editor {
    .el-input__inner {
      padding-left: 10px;
    }
  }
}
.address-content {
  display: flex;
  margin-bottom: 10px;
  padding: 15px;
  background: #ebeef5;
  .adressBox {
    display: inline-block;
    .item {
      display: inline-block;
      margin-right: 6px;
    }
    .defTab {
      padding: 3px 10px;
      display: inline-block;
      background: #1b73ff;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
}
</style>
